import { render } from "./MintTitleDivider.vue?vue&type=template&id=125b8bb4&scoped=true"
import script from "./MintTitleDivider.vue?vue&type=script&lang=js"
export * from "./MintTitleDivider.vue?vue&type=script&lang=js"

import "./MintTitleDivider.vue?vue&type=style&index=0&id=125b8bb4&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125b8bb4"]])

export default __exports__